import { render, staticRenderFns } from "./SmallClass.vue?vue&type=template&id=1ca65aec&scoped=true"
import script from "./SmallClass.vue?vue&type=script&lang=js"
export * from "./SmallClass.vue?vue&type=script&lang=js"
import style0 from "./SmallClass.vue?vue&type=style&index=0&id=1ca65aec&prod&scoped=true&lang=stylus"
import style1 from "./SmallClass.vue?vue&type=style&index=1&id=1ca65aec&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca65aec",
  null
  
)

export default component.exports